import { optionLabel } from "../../configurazione/adapters";
import { useLogisticaConfiguration, withLogisticaConfiguration } from "../../configurazione/LogisticaConfigurationProvider";
import React, { useState, useEffect } from "react";
import apiUrl from "../../../Apiurl";
import axios from "axios";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import { createPortal } from "react-dom";
import { useAuth0 } from "@auth0/auth0-react";
import CSVuploadQuery90 from "../../../importCSV/varieQueries/CSVuploadQuery90";
import CSVuploadTrackingBRT from "../../../importCSV/varieQueries/CSVuploadTrackingBRT";
import CSVuploadTrackingDHL from "../../../importCSV/varieQueries/CSVuploadTrackingDHL";
import apriUrl from "../../../interfaccia/funzioniComuni/apriUrl";

function FunzioniOrdiniPOP({
  setPopUpWindow,
  creaOrdine,
  importaOrdini,
  importaTracking,
  tema,
}) {
  const { datiTendineOrdine } = useLogisticaConfiguration();

  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [popUpWindow2, setPopUpWindow2] = useState(false);
  const [input, setInput] = useState({
    dataSpediti: "",
    magazzino: "",
  });

  const {
    tastoCercaAspetto,
    tastoChiudiAspetto,
    tastoNuovoAspetto,
    tastoImportAspetto,
    tastoRefreshAspetto,
    tastoExportAspetto,
    inputClasses,
  } = stilePulsanti;

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  function chiudi(e) {
    e.preventDefault();
    setPopUpWindow(false);
  }

  // TODO cambi massivi temporaneamente disattivati perché da aggiornare con il nuovo registro dei cambi stato

  const impostaStatoDaStatoEMAG = async function (
    nuovoStato,
    vecchioStato,
    magazzino
  ) {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    try {
      //TODO aggiornare questa alla nuova funzione universale cambioMassivo
      const data = {
        nuovoStato: nuovoStato,
        vecchioStato: vecchioStato,
        userName: user.name,
        funzione: "impostaStato",
        magazzino: magazzino,
        dataSped: null,
      };
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      /////////// OBSOLETA !!!!! ///////////////////
      axios.patch(
        apiUrl + "/logistica/funzioni/cambioStatoEDataMassivoDaStatoEMAGAZZINO",
        data,
        config
      );
      /* .then((resp) => {
                    if (resp.data.errno) {
                        setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                    } else {
                        setAlertSalvataggio(false)
                        setResultSalvataggio(resp.data)
                        setSalvato(true);
                    }
                }) */
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date = new Date()) {
    return [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join("-");
  }

  const setFinestra = function (e, finestra) {
    e.preventDefault();
    setPopUpWindow2(finestra);
  };

  const handleChange = async function (evt) {
    const value = evt.target.value;
    try {
      setInput({
        ...input,
        [evt.target.name]: value,
      });
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato non nestato: " + err);
      throw err;
    }
  };

  const exportData = (data) => {
    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify(data)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "data.json";

    link.click();
  };

  const aggiornaStatiJSON = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    try {
      fetch(apiUrl + "/logistica/ps/cambiaStatiSuPS", {
        method: "PATCH",
        headers: { Authorization: "Bearer " + token },
      })
        .then((resp) => resp.json())
        .then((data) => exportData(data)); //TODO invece di scaricare il json visualizzare risposta in finestra
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  const aggiornaSpeditiJSON = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    if (!input.dataSpediti || input.dataSpediti === "") {
      alert("Seleziona prima una data dalla tendina");
    } else {
      try {
        fetch(
          apiUrl +
            "/logistica/ps/cambiaStatiSuPSfunzioneSpeditiDATA/" +
            input.dataSpediti,
          { method: "PATCH", headers: { Authorization: "Bearer " + token } }
        )
          .then((resp) => resp.json())
          .then((data) => exportData(data)); //TODO invece di scaricare il json visualizzare risposta in finestra
      } catch (err) {
        console.log("Errore nell'invio degli ordini alle API': " + err);
        throw err;
      }
    }
  };

  const jsonTEST = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    try {
      fetch(apiUrl + "/jsonProdottiPerTembo", {
        headers: { Authorization: "Bearer " + token },
      })
        .then((resp) => resp.json())
        .then((data) => exportData(data)); //TODO invece di scaricare il json visualizzare risposta in finestra
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  const exportBRT = async function (mag) {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    /* if (!input.dataSpediti) {
            alert("Seleziona prima una data");
        } */
    try {
      fetch(apiUrl + "/logistica/csv/exportBRTeasySpedWeb/" + mag, {
        headers: { Authorization: "Bearer " + token },
      })
        .then((resp) => resp.json())
        .then((data) => apriUrl(data));
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  const exportCSVtrackingPS = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    if (!input.dataSpediti) {
      alert("Seleziona prima una data");
    }
    try {
      fetch(apiUrl + "/logistica/csv/exportTrack_DB_PS/" + input.dataSpediti, {
        headers: { Authorization: "Bearer " + token },
      })
        .then((resp) => resp.json())
        .then((data) => apriUrl(data));
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  const expAHcorrispettivi = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    if (!input.dataSpediti) {
      alert("Seleziona prima una data");
    }
    try {
      fetch(apiUrl + "/logistica/csv/expAHcorrispettivi/" + input.dataSpediti, {
        headers: { Authorization: "Bearer " + token },
      })
        .then((resp) => resp.json())
        .then((data) => apriUrl(data));
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  const expAHfatture = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    if (!input.dataSpediti) {
      alert("Seleziona prima una data");
    }
    try {
      fetch(apiUrl + "/logistica/csv/expAHfatture/" + input.dataSpediti, {
        headers: { Authorization: "Bearer " + token },
      })
        .then((resp) => resp.json())
        .then((data) => apriUrl(data));
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  const expAHspeditiTutti = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    if (!input.dataSpediti) {
      alert("Seleziona prima una data");
    }
    try {
      fetch(apiUrl + "/logistica/csv/expAHspeditiTutti/" + input.dataSpediti, {
        headers: { Authorization: "Bearer " + token },
      })
        .then((resp) => resp.json())
        .then((data) => apriUrl(data));
    } catch (err) {
      console.log("Errore nell'invio degli ordini alle API': " + err);
      throw err;
    }
  };

  function esportaPDFattese() {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }

    fetch(apiUrl + "/logistica/pdf/tutteLeAttese", {
      headers: { Authorization: "Bearer " + token },
    })
      .then((resp) => resp.json())
      .then((data) => apriUrl(data));
  }

  return (
    <div className="pa2 f6">
      <div className="tr">
        <button className="dim tastoInputOrizzontale br3 br3" onClick={chiudi}>
          {tastoChiudiAspetto}
        </button>
      </div>
      <div className="mt2 pt3 pb3 flex">
        <div className="ml2 pa4">
          <h3 className="mb4">Spedizione</h3>
          <div className="flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={creaOrdine}
            >
              {tastoNuovoAspetto}
            </button>
            <span className="w-70">Crea spedizione a manina</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={aggiornaStatiJSON}
            >
              {tastoRefreshAspetto}
            </button>
            <span className="w-70">Forza cambio stati su PS</span>
          </div>
          {/* // TODO cambi massivi temporaneamente disattivati perché da aggiornare con il nuovo registro dei cambi stato */}
          <div className="bt bordoColAlt mt3 mb3 pt3 tc b">
            Cambi di stato massivi
          </div>
          <div className="mb3">prima scegli un magazzino</div>
          <div className="tc">
            <select
              name="magazzino"
              onChange={handleChange}
              value={input.magazzino}
              className={"db measure ba bordoColScrittaDef-10 pa2 br2 mb2"}
            >
              {datiTendineOrdine.partenzaDa.map((mag, i) => (
                <option key={i + 1} value={mag}>
                  {optionLabel(datiTendineOrdine.partenzaDa, mag)}
                </option>
              ))}
            </select>
          </div>
          {input.magazzino !== "" && (
            <div className=" flex items-center flex-wrap justify-between mb2">
              <button
                className="tastoInputOrizzontale br3 dim w-20"
                onClick={(e) => {
                  impostaStatoDaStatoEMAG(
                    "TROVATO",
                    "RICERCA",
                    input.magazzino
                  );
                }}
              >
                TRO
              </button>
              <span className="w-70">
                Ricerca-{"> "}TROVATI su {input.magazzino}
              </span>
            </div>
          )}
          {/* 
                    <div className=' flex items-center flex-wrap justify-between mb2'>
                        <button className="tastoInputOrizzontale br3 dim w-20" onClick={(e) => { impostaStato("PRONTO EXP", "PREPARAZIONE", formatDate()) }}>EXP</button><span className="w-70">Preparazione-{'> '}PRONTO EXP oggi</span>
                    </div>
                    <div className=' flex items-center flex-wrap justify-between mb2'>
                        <button className="tastoInputOrizzontale br3 dim w-20" onClick={(e) => { impostaStato("ETICHETTE", "PRONTO EXP", formatDate()) }}>ETI</button><span className="w-70">Pronto exp-{'> '}ETI oggi</span>
                    </div>
                    <div className=' flex items-center flex-wrap justify-between mb2'>
                        <button className="tastoInputOrizzontale br3 dim w-20" onClick={(e) => { impostaStatoDaData("SPEDITO", "ETICHETTE", formatDate()) }}>SPD</button><span className="w-70">ETI-{'> '}Spedito oggi</span>
                    </div> */}
        </div>
        <div className="ml2 pa4 bl bordoColAlt">
          <h3 className="mb4">Import</h3>
          <div className="bt bordoColAlt mt3 mb3 pt3 tc b">
            Importa dati da ps
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={importaOrdini}
            >
              {tastoImportAspetto}
            </button>
            <span className="w-70">Forza import ordini da PS</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={importaTracking}
            >
              {tastoImportAspetto}
            </button>
            <span className="w-70">Forza import tracking da PS</span>
          </div>
          <div className="bt bordoColAlt mt3 mb3 pt3 tc b">
            Importa dati da csv
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={(e) => {
                setFinestra(e, "caricaCSV");
              }}
            >
              {tastoImportAspetto}
            </button>
            <span className="w-70">Importazione manuale ordini</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={(e) => {
                setFinestra(e, "trackingBRT");
              }}
            >
              {tastoImportAspetto}
            </button>
            <span className="w-70">Importa tracking BRT da csv filezilla</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={(e) => {
                setFinestra(e, "trackingDHL");
              }}
            >
              {tastoImportAspetto}
            </button>
            <span className="w-70">Importa tracking DHL da nuova area</span>
          </div>
        </div>
        <div className="ml2 pa4 bl bordoColAlt">
          <h3 className="mb4">Export spediti in data</h3>
          <div className="tc">
            <label for="dataSpediti">Export ordini spediti il</label>
            <br />
            <input
              type="date"
              name="dataSpediti"
              onChange={handleChange}
              value={input.dataSpediti}
              className={"db measure ba bordoColScrittaDef-10 pa2 br2 mb2"}
            ></input>
          </div>

          <div className="bt bordoColAlt mt3 mb3 pt3 tc b">
            Esporta dati per AdHoc
          </div>
          {/* <div className=' flex items-center flex-wrap justify-between mb2'>
                        <button className="tastoInputOrizzontale br3 dim w-20" onClick={expAHcorrispettivi}>{tastoExportAspetto}</button><span className="w-70">Esporta corrispettivi</span>
                    </div>
                    <div className=' flex items-center flex-wrap justify-between mb2'>
                        <button className="tastoInputOrizzontale br3 dim w-20" onClick={expAHfatture}>{tastoExportAspetto}</button><span className="w-70">Esporta fatture</span>
                    </div> */}
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={expAHspeditiTutti}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Esporta spediti</span>
          </div>
          <div className="bt bordoColAlt mt3 mb3 pt3 tc b">
            Esporta dati per PrestaShop
          </div>

          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={exportCSVtrackingPS}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Export CSV tracking per PS</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={aggiornaSpeditiJSON}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">
              Forza spediti {input.dataSpediti} su ps
            </span>
          </div>
        </div>
        <div className="ml2 pa4 bl bordoColAlt">
          <h3 className="mb4">Export PRONTO EXP</h3>
          <div className="bt bordoColAlt mt3 mb3 pt3 tc b">
            Esporta dati per corrieri
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={() => exportBRT("Prato Nevoso")}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Export pronto exp per BRT PRATO</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={() => exportBRT("Torino")}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Export pronto exp per BRT TORINO</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={() => exportBRT("Villanova Mondovì")}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Export pronto exp per BRT VILLANOVA</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={() => exportBRT("Vernante")}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Export pronto exp per BRT VERNANTE</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={() => exportBRT("Magazzino Marro (area VS)")}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Export pronto exp per BRT MARRO VS</span>
          </div>
          <div className=" flex items-center flex-wrap justify-between mb2">
            <button
              className="tastoInputOrizzontale br3 dim w-20"
              onClick={() => exportBRT("Magazzino Marro")}
            >
              {tastoExportAspetto}
            </button>
            <span className="w-70">Export pronto exp per BRT MARRO</span>
          </div>
        </div>
        {/* {tema === "vik" && <div className='ml2 pa4 bl bordoColAlt'>
                    <h3 className='mb4'>Debug</h3>
                    {tema === "vik" && <div className=' flex items-center flex-wrap justify-between mb2'>
                        <button className="tastoInputOrizzontale br3 dim w-20" onClick={jsonTEST}>{tastoExportAspetto}</button><span className="w-70">JSON TEST</span>
                    </div>}
                    {tema === "vik" && <div className=' flex items-center flex-wrap justify-between mb2'>
                        <button className="tastoInputOrizzontale br3 dim w-20" onClick={esportaPDFattese}>{tastoExportAspetto}</button><span className="w-70">PDF attese TEST</span>
                    </div>}
                    
                </div>} */}
      </div>
      {popUpWindow2 === "caricaCSV" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              <div className={"bg-white " + tema + " finestraPopUp"}>
                <CSVuploadQuery90 setPopUpWindow={setPopUpWindow2} />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow2 === "trackingBRT" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              <div className={"bg-white " + tema + " finestraPopUp"}>
                <CSVuploadTrackingBRT setPopUpWindow={setPopUpWindow2} />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
      {popUpWindow2 === "trackingDHL" && (
        <div>
          {createPortal(
            <div id="modal-root">
              <div className="modal" onClick={chiudi}></div>
            </div>,
            document.body
          )}
          {createPortal(
            <div id="modal-content">
              <div className={"bg-white " + tema + " finestraPopUp"}>
                <CSVuploadTrackingDHL setPopUpWindow={setPopUpWindow2} />
              </div>
            </div>,
            document.body
          )}
        </div>
      )}
    </div>
  );
}

export default withLogisticaConfiguration(FunzioniOrdiniPOP);
